import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '@/views/Home.vue'
import Login from '@/views/Login.vue'
import Event from '@/views/Event.vue'
import EventRecap from '@/views/EventRecap.vue'
import EventInterimaire from '@/views/EventInterimaire.vue'
import EventSignatureClient from '@/views/EventSignatureClient.vue'
import Vehicles from '@/views/Vehicles.vue'
import VehicleForm from '@/views/VehicleForm.vue'
import Vehicle from '@/views/Vehicle.vue'
import store from '@/store/index';

Vue.use(VueRouter)

const routes = [
  {
    path: '/login',
    name: 'login',
    component: Login,
    meta: {
      title: 'Login',
      logLayout: true,
    },
  },
  {
    path: '/',
    name: 'home',
    meta: {
      title: 'Accueil',
      logLayout: false,
    },
    component: Home
  },
  {
    path: '/event/:eventid',
    name: 'event',
    meta: {
      title: 'RDV',
      logLayout: false,
    },
    component: Event,
    props: true
  },
  {
    path: '/recap/:eventid',
    name: 'eventRecap',
    meta: {
      title: 'Récap',
      logLayout: false,
    },
    component: EventRecap,
    props: true
  },
  {
    path: '/interimaire/:eventid',
    name: 'eventInterimaire',
    meta: {
      title: 'Intérimaire',
      logLayout: false,
    },
    component: EventInterimaire,
    props: true
  },
  {
    path: '/signatureclient/:eventid',
    name: 'eventSignatureClient',
    meta: {
      title: 'Signature',
      logLayout: false,
    },
    component: EventSignatureClient,
    props: true
  },
  {
    path: '/vehicles/:eventid',
    name: 'vehicles',
    meta: {
      title: 'véhicules',
      logLayout: false,
    },
    component: Vehicles,
    props: true
  },
  {
    path: '/vehicle/:eventid/:vehicleid',
    name: 'vehicle',
    meta: {
      title: 'véhicule',
      logLayout: false,
    },
    component: Vehicle,
    props: true
  },
  {
    path: '/vehicles/:eventid/add',
    name: 'VehicleForm',
    meta: {
      title: 'Nouveau véhicule',
      logLayout: false,
    },
    component: VehicleForm,
    props: true
  },
  {
    path: '/logs',
    name: 'logs',
    meta: {
      title: 'Logs',
      logLayout: false,
    },
    component: () => import(/* webpackChunkName: "logs" */ '@/views/Logs.vue')

  }
]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  }
})

const waitForStorageToBeReady = async (to, from, next) => {
  console.log('waitForStorageToBeReady');
  await store.restored
  next()
}
router.beforeEach(waitForStorageToBeReady)


router.beforeEach((to, from, next) => {
  const token = store.getters['login/getToken'];
  console.log('token', token, to.name);

  if (token === null && to.name !== 'login') {
      next({'name': 'login', replace: true});
  }
  else if (to.name === 'login' && token !== null ) {
       next({'name': 'home', replace: true});
  }else{
    // on cache le loader qui est dans le header
    jQuery('#page-header-loader').removeClass('show');
    next();
  }
});

export default router
